export function featuredProductsSlider() {
    const $slider = $(".featured-products-slider");
    $slider.each(function () {
        const $this = $(this);

        $this.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            nextArrow: "<button class=\"slide-arrow slick-next\" aria-label=\"button-next\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\"><path d=\"M11.667 19.8332L17.5003 13.9998L11.667 8.1665\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button>",
            prevArrow: "<button class=\"slide-arrow slick-prev\" aria-label=\"button-prev\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" style=\"transform: scaleX(-1);\"><path d=\"M11.667 19.8332L17.5003 13.9998L11.667 8.1665\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button>",
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuredProductsSlider.js